// extracted by mini-css-extract-plugin
export var modal = "_dn-0";